<template>
    <div>
      <layout-header></layout-header>
      <div class="complaint-form mt-5 mb-5 container">
        <div class="row">
          <div class="col-md-6">
            <div class="image-container">
              <img :src="require('@/assets/img/complain.png')" alt="Complaint Image" class="img-fluid mt-2" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-area">
              <h2>Describe your Complaints Pains or Ailment:</h2>
              <textarea class="mt-2 form-control" v-model="subjectMatter" placeholder="Type your complaints here..." maxlength="1000"></textarea>
  
              <!-- Display character count in real-time -->
              <div v-if="showError" class="text-danger mt-3">Please fill in the complaint.</div>
              <div class="row ml-2">
                <div class="col-6 mt-2 text-left">
                <input type="checkbox" class="form-check-input" id="shareWithDoctor" v-model="shareWithDoctor" />
                <label class="form-check-label" for="shareWithDoctor">Share with doctor</label>
              </div>
              <div class="col-6 mt-2 text-right">
                <p>{{ characterCount }} / 1000 characters</p>
              </div>
              </div>
               <!-- Add a loader element -->
      <div v-if="showLoader" class="text-center">
        <div class="spinner-border text-success" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
  
              <!-- Add the submit button with Bootstrap "Success" style -->
              <button @click="submitComplaint" class="btn btn-success" style="width:100px;">Submit</button>
            </div>
          </div>
        </div>
      </div>
      <layout-footer></layout-footer>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        imageUrl: '@/assets/img/complain.png',
        subjectMatter: '',
        responseData: null,
        shareWithDoctor: false,
        showError: false,
        showLoader: false, // Initialize the loader property
      };
    },
    computed: {
      characterCount() {
        return this.subjectMatter.length;
      },
    },
    methods: {
      async submitComplaint() {
        if (!this.subjectMatter.trim()) {
          this.showError = true;
          return;
        }
  
        try {
          // Show the loader while waiting for the response
          this.showLoader = true;
  
          const requestData = {
            subject_matter: this.subjectMatter,
          };
  
          const response = await axios.post(
            'https://app.bhilwarahealthcare.in/api/method/sahaj.doctor_bot.patient_complaints',
            requestData
          );
  
          if (response && response.status === 200) {
            this.responseData = response.data.message.departments;
            this.$router.push({
              name: 'search-complain',
              params: { data: this.responseData },
            });
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'Error',
              text: response.data.message || 'An error occurred while submitting the complaint.',
              showConfirmButton: true,
            });
          }
  
          this.subjectMatter = '';
          this.showError = false;
        } catch (error) {
          console.error('Error:', error);
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while submitting the complaint.',
            showConfirmButton: true,
          });
        } finally {
          // Hide the loader whether the request succeeds or fails
          this.showLoader = false;
        }
      },
    },
  };
  </script>
  
  
  

<style scoped>
.complaint-form {
  margin: 0 auto;
  padding: 20px;
}

.image-container img {
  width: 100%;
  height: auto;
  border-radius: 15px;
  }

h2 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

textarea {
  width: 100%;
  height: 200px;
  padding: 10px;
  border: 1px solid #ae2626;
  border-radius: 5px;
  font-size: 1rem;
}

.form-check {
  display: flex;
  align-items: center;
}

.form-check-label {
  margin-left: 10px;
}

.btn {
  width: 12%;
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/DescribeComplain.vue